import VoucherExperiment from '~/experiments/voucher.experiment'

export default [
  VoucherExperiment,
]
